// extracted by mini-css-extract-plugin
export default {"quoteWrapper":"Quote_quoteWrapper__MYOVc","quoteContent":"Quote_quoteContent__A2CSd","quoteText":"Quote_quoteText__hpRP-","quoteAuthor":"Quote_quoteAuthor__Fnmei"};